import React, { useEffect, useRef } from 'react';
var SnippylyRecorderControlPanel = function (props) {
    var mode = props.mode, panelId = props.panelId, onRecordedData = props.onRecordedData;
    var ref = useRef();
    var onRecordedDataRef = useRef(onRecordedData);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onRecordedDataRef.current = onRecordedData;
    }, [onRecordedData]);
    useEffect(function () {
        var element;
        var handleRecordedData = function (event) {
            if (onRecordedDataRef.current) {
                onRecordedDataRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onRecordedData', handleRecordedData);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onRecordedData', handleRecordedData);
            }
        };
    }, []);
    return (React.createElement("velt-recorder-control-panel", { ref: ref, mode: mode, "panel-id": panelId }));
};
export default SnippylyRecorderControlPanel;
